function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable prefer-destructuring */
import { merge } from '@gympass/yoga-common';
import _componentThemes_AutoComplete$AutoComplete from "./../../AutoComplete/AutoComplete.theme.js";
import _componentThemes_Avatar$Avatar from "./../../Avatar/Avatar.theme.js";
import _componentThemes_Banner$Banner from "./../../Banner/Banner.theme.js";
import _componentThemes_BottomSheet$BottomSheet from "./../../BottomSheet/BottomSheet.theme.js";
import _componentThemes_Button$Button from "./../../Button/Button.theme.js";
import _componentThemes_Card$CardNative from "./../../Card/Card.native.theme.js";
import _componentThemes_Card$Card from "./../../Card/Card.theme.js";
import _componentThemes_Card$CardWeb from "./../../Card/Card.web.theme.js";
import _componentThemes_Checkbox$Checkbox from "./../../Checkbox/Checkbox.theme.js";
import _componentThemes_Checkbox$CheckboxSwitch from "./../../Checkbox/CheckboxSwitch.theme.js";
import _componentThemes_Datepicker$Datepicker from "./../../Datepicker/Datepicker.theme.js";
import _componentThemes_Dialog$Dialog from "./../../Dialog/Dialog.theme.js";
import _componentThemes_Divider$Divider from "./../../Divider/Divider.theme.js";
import _componentThemes_Drawer$Drawer from "./../../Drawer/Drawer.theme.js";
import _componentThemes_Dropdown$Dropdown from "./../../Dropdown/Dropdown.theme.js";
import _componentThemes_Feedback$Feedback from "./../../Feedback/Feedback.theme.js";
import _componentThemes_Grid$Grid from "./../../Grid/Grid.theme.js";
import _componentThemes_Header$Header from "./../../Header/Header.theme.js";
import _componentThemes_Heading$Heading from "./../../Heading/Heading.theme.js";
import _componentThemes_Icon$Icon from "./../../Icon/Icon.theme.js";
import _componentThemes_Input$Input from "./../../Input/Input.theme.js";
import _componentThemes_List$List from "./../../List/List.theme.js";
import _componentThemes_Menu$Menu from "./../../Menu/Menu.theme.js";
import _componentThemes_Progress$Progress from "./../../Progress/Progress.theme.js";
import _componentThemes_RadioGroup$RadioGroup from "./../../RadioGroup/RadioGroup.theme.js";
import _componentThemes_Rating$Rating from "./../../Rating/Rating.theme.js";
import _componentThemes_Result$Result from "./../../Result/Result.theme.js";
import _componentThemes_Skeleton$Skeleton from "./../../Skeleton/Skeleton.theme.js";
import _componentThemes_Slider$Slider from "./../../Slider/Slider.theme.js";
import _componentThemes_Snackbar$Snackbar from "./../../Snackbar/Snackbar.theme.js";
import _componentThemes_Stepper$Stepper from "./../../Stepper/Stepper.theme.js";
import _componentThemes_Tag$Tag from "./../../Tag/Tag.theme.js";
import _componentThemes_Text$Text from "./../../Text/Text.theme.js";
import _componentThemes_TextArea$TextArea from "./../../TextArea/TextArea.theme.js";
var componentThemes = {
  AutoComplete$AutoComplete: _componentThemes_AutoComplete$AutoComplete,
  Avatar$Avatar: _componentThemes_Avatar$Avatar,
  Banner$Banner: _componentThemes_Banner$Banner,
  BottomSheet$BottomSheet: _componentThemes_BottomSheet$BottomSheet,
  Button$Button: _componentThemes_Button$Button,
  Card$CardNative: _componentThemes_Card$CardNative,
  Card$Card: _componentThemes_Card$Card,
  Card$CardWeb: _componentThemes_Card$CardWeb,
  Checkbox$Checkbox: _componentThemes_Checkbox$Checkbox,
  Checkbox$CheckboxSwitch: _componentThemes_Checkbox$CheckboxSwitch,
  Datepicker$Datepicker: _componentThemes_Datepicker$Datepicker,
  Dialog$Dialog: _componentThemes_Dialog$Dialog,
  Divider$Divider: _componentThemes_Divider$Divider,
  Drawer$Drawer: _componentThemes_Drawer$Drawer,
  Dropdown$Dropdown: _componentThemes_Dropdown$Dropdown,
  Feedback$Feedback: _componentThemes_Feedback$Feedback,
  Grid$Grid: _componentThemes_Grid$Grid,
  Header$Header: _componentThemes_Header$Header,
  Heading$Heading: _componentThemes_Heading$Heading,
  Icon$Icon: _componentThemes_Icon$Icon,
  Input$Input: _componentThemes_Input$Input,
  List$List: _componentThemes_List$List,
  Menu$Menu: _componentThemes_Menu$Menu,
  Progress$Progress: _componentThemes_Progress$Progress,
  RadioGroup$RadioGroup: _componentThemes_RadioGroup$RadioGroup,
  Rating$Rating: _componentThemes_Rating$Rating,
  Result$Result: _componentThemes_Result$Result,
  Skeleton$Skeleton: _componentThemes_Skeleton$Skeleton,
  Slider$Slider: _componentThemes_Slider$Slider,
  Snackbar$Snackbar: _componentThemes_Snackbar$Snackbar,
  Stepper$Stepper: _componentThemes_Stepper$Stepper,
  Tag$Tag: _componentThemes_Tag$Tag,
  Text$Text: _componentThemes_Text$Text,
  TextArea$TextArea: _componentThemes_TextArea$TextArea
};
Object.freeze(componentThemes);

var getComponentThemes = function getComponentThemes(tokens) {
  var colors = tokens.colors,
      baseFont = tokens.baseFont,
      baseFontSize = tokens.baseFontSize;
  var components = Object.entries(componentThemes).reduce(function (componentsStyles, _ref) {
    var _extends2;

    var names = _ref[0],
        themed = _ref[1];

    var _names$toLowerCase$sp = names.toLowerCase().split('$'),
        name = _names$toLowerCase$sp[1];

    return _extends({}, componentsStyles, (_extends2 = {}, _extends2[name] = themed(_extends({}, tokens, {
      colors: colors,
      baseFont: baseFont,
      baseFontSize: baseFontSize
    })), _extends2));
  }, {});
  return {
    components: components
  };
};

var theme = function theme(tokens) {
  var baseFont = tokens.fonts.rubik;
  var baseFontSize = tokens.fontSizes.medium;

  var colors = _extends({}, tokens.colors, {
    primary: tokens.colors.vibin,
    secondary: tokens.colors.stamina,
    feedback: {
      success: [tokens.colors.success, tokens.colors.hope],
      informative: [tokens.colors.neutral, tokens.colors.relax],
      attention: [tokens.colors.attention, tokens.colors.verve],
      neutral: [tokens.colors.light, tokens.colors.medium]
    },
    text: {
      primary: tokens.colors.stamina,
      secondary: tokens.colors.deep,
      disabled: tokens.colors.light
    },
    elements: {
      selectionAndIcons: tokens.colors.medium,
      lineAndBorders: tokens.colors.light,
      backgroundAndDisabled: tokens.colors.clear
    }
  });

  var _colors$feedback$succ = colors.feedback.success;
  colors.feedback.success.light = _colors$feedback$succ[0];
  colors.feedback.success.dark = _colors$feedback$succ[1];
  var _colors$feedback$info = colors.feedback.informative;
  colors.feedback.informative.light = _colors$feedback$info[0];
  colors.feedback.informative.dark = _colors$feedback$info[1];
  var _colors$feedback$atte = colors.feedback.attention;
  colors.feedback.attention.light = _colors$feedback$atte[0];
  colors.feedback.attention.dark = _colors$feedback$atte[1];
  var _colors$feedback$neut = colors.feedback.neutral;
  colors.feedback.neutral.light = _colors$feedback$neut[0];
  colors.feedback.neutral.dark = _colors$feedback$neut[1];
  return _extends({}, tokens, {
    colors: colors,
    baseFont: baseFont,
    baseFontSize: baseFontSize
  });
};

var composeTheme = function composeTheme(tokens, customTheming) {
  if (customTheming === void 0) {
    customTheming = {};
  }

  var baseTheme = theme(tokens);
  var customTheme = merge(baseTheme, customTheming);
  var componentTheming = getComponentThemes(customTheme);
  return merge(customTheme, componentTheming);
};

export default composeTheme;